"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Link_1 = require("./Link");
exports.default = Link_1.default;
//# sourceMappingURL=index.js.map